import React, { useState, useEffect } from "react";
import { View, Platform } from "react-native";
import { styles } from "./InputSelect.styles";
import { Picker } from "@react-native-picker/picker";
import { theme } from "../../../../theme";
export const InputSelect = ({ placeholder, disabled = false, options: initialOptions, onChange, onFocus, onBlur, styles: userStyles, isLoading, itemStyles, defaultValue, ...rest }) => {
    const [selected, setSelected] = useState();
    const [options, setOptions] = useState(initialOptions);
    const [isOpen, setOpen] = useState(false);
    const isDisabled = disabled || !options.length;
    useEffect(() => {
        setOptions(initialOptions);
    }, [initialOptions]);
    useEffect(() => {
        if (onChange && selected) {
            onChange(String(selected.value));
        }
    }, [selected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: [styles.container, isLoading && styles.loading, userStyles] },
            React.createElement(Picker, { selectedValue: selected?.value ?? defaultValue, onValueChange: (itemValue) => {
                    if (itemValue) {
                        setSelected(options.find(({ value }) => value === itemValue));
                    }
                }, enabled: !isDisabled, dropdownIconColor: isDisabled ? theme.colors.brand.lightest : theme.colors.brand.base, onFocus: () => {
                    setOpen(true);
                    onFocus?.();
                }, onBlur: () => {
                    setOpen(false);
                    onBlur?.();
                }, style: styles.picker, itemStyle: [styles.items, itemStyles], ...rest },
                placeholder && (React.createElement(Picker.Item, { label: placeholder, color: Platform.OS === "ios"
                        ? theme.colors.dark.base
                        : theme.colors.greyscale.lighter, enabled: !isOpen })),
                disabled && !options.length && !placeholder && (React.createElement(Picker.Item, { label: "" })),
                options.map((option, index) => (React.createElement(Picker.Item, { key: `${option.value}_${index}`, color: isDisabled
                        ? theme.colors.greyscale[Platform.OS === "android" ? "lightest" : "light"]
                        : theme.colors.dark.base, ...option }))))),
        isDisabled && Platform.OS === "ios" && (React.createElement(View, { style: styles.disabledIOSView }))));
};
//# sourceMappingURL=InputSelect.js.map